export default __webpack_public_path__ + "static/media/kitchen4-afterB-1024w.23755fc2.avif";